import type { ZodType } from 'zod';
import { logApiValidationFailure } from './apiValidationLog';
import { toStripView } from './stripView';

/**
 * Validate an API response against a Zod schema.
 *
 * Parses through a strip view of the schema (see `stripView.ts`), so keys this
 * bundle does not know about are dropped rather than failing validation.
 *
 * Observational: logs validation issues but never throws or crashes.
 * Returns parsed data on success, original data on failure.
 */
export function validateResponse<T>(
  schema: ZodType<T>,
  data: unknown,
  endpoint: string,
): T {
  // Strip view: extra keys added by a newer server must not demote a good payload to raw data.
  const result = toStripView(schema).safeParse(data);
  if (!result.success) {
    logApiValidationFailure(endpoint, result.error.issues);
    return data as T;
  }
  return result.data;
}
